import CONFIG from "../temp/config";
import React, {Component} from 'react';
import './TrustPilot.css';

export let TRUST_PILOT_TEMPLATE = {

    Carousel:'53aa8912dec7e10d38f59f36',
    Dropdown:'5418052cfbfb950d88702476',
    Grid:'539adbd6dec7e10e686debee',
    List:'539ad60defb9600b94d7df2c',
    Micro:'5419b637fa0340045cd0c936',
    Mini:'53aa8807dec7e10d38f59f32',
    Slider: '54ad5defc6454f065c28af8b',
    Starter:'5613c9cde69ddc09340c6beb',

};

export let TRUST_PILOT_THEME = {

    light:'light',
    dark:'dark',

};

let TRUST_PILOT_SETTINGS = {

    scriptUrl: 'https://widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js',
    className: 'trustpilot-widget', //Cannot change this, expected from TrustPilot

};

let TRUST_PILOT_DISPLAY_SETTINGS_DEFAULT = {

    locale: 'en-US',
    theme: TRUST_PILOT_THEME.dark,
    font: 'Montserrat',
    height: '150px',
    width: '100%',

};

let TRUST_PILOT_DISPLAY_SETTINGS_MINI = {

    locale: 'en-US',
    theme: TRUST_PILOT_THEME.dark,
    font: 'Montserrat',
    height: '150px',
    width: '100%',

};

export let getTrustpilotDisplaySettings = (template) => {

    switch (template) {
        case TRUST_PILOT_TEMPLATE.Mini:
            return TRUST_PILOT_DISPLAY_SETTINGS_MINI;
        default:
            return TRUST_PILOT_DISPLAY_SETTINGS_DEFAULT;
    }

};

let appendScriptToHeader = (scriptToAppend) => {
    const script = document.createElement("script");
    script.src = scriptToAppend;
    script.async = true;
    document.head.appendChild(script);
};

class TrustBoxContainer extends Component {
    constructor(props) {
        super(props);
        this.trustBoxRef = React.createRef();
    }

    componentDidMount() {

        appendScriptToHeader(TRUST_PILOT_SETTINGS.scriptUrl);

        // If window.Trustpilot is available it means that we need to load the TrustBox from our ref.
        // If it's not, it means the script you pasted into <head /> isn't loaded just yet.
        // When it is, it will automatically load the TrustBox.
        if (window.Trustpilot) {
            window.Trustpilot.loadFromElement(this.trustBoxRef.current, true);
        }
    }

    render() {
        return (
            <div
                ref={this.trustBoxRef}
                className={TRUST_PILOT_SETTINGS.className}
                data-locale={this.props.tpLocale?this.props.tpLocale:TRUST_PILOT_DISPLAY_SETTINGS_DEFAULT.locale}
                data-template-id={this.props.tpTemplate?this.props.tpTemplate:TRUST_PILOT_TEMPLATE.Mini}
                data-businessunit-id={CONFIG.trustpilotBusinessId}
                data-style-height={this.props.tpHeight?this.props.tpHeight:TRUST_PILOT_DISPLAY_SETTINGS_DEFAULT.height}
                data-style-width={this.props.tpWidth?this.props.tpWidth:TRUST_PILOT_DISPLAY_SETTINGS_DEFAULT.width}
                data-theme={this.props.tpTheme?this.props.tpTheme:TRUST_PILOT_DISPLAY_SETTINGS_DEFAULT.theme}
                data-font-family={this.props.tpFont?this.props.tpFont:TRUST_PILOT_DISPLAY_SETTINGS_DEFAULT.font}
                max-width={this.props.tpMaxWidth?this.props.tpMaxWidth:'100%'}
                data-stars={'4,5'}
            >
                <a href="https://www.trustpilot.com/review/example.com"
                   target="_blank"
                   rel="noopener noreferrer"
                >
                    Trustpilot
                </a>
            </div>

        )
    }
}

/*

<!-- TrustBox widget - Mini -->
<div class="trustpilot-widget" data-locale="en-US" data-template-id="53aa8807dec7e10d38f59f32"
data-businessunit-id="58de7df20000ff00059f96e1" data-style-height="100px" data-style-width="100%" data-theme="light"
data-font-family="Montserrat" data-text-color="#ffffff">
  <a href="https://www.trustpilot.com/review/nsre.com" target="_blank" rel="noopener">Trustpilot</a>
</div>
<!-- End TrustBox widget -->


<!-- TrustBox widget - Starter -->
<div class="trustpilot-widget" data-locale="en-US" data-template-id="5613c9cde69ddc09340c6beb"
data-businessunit-id="58de7df20000ff00059f96e1" data-style-height="100%" data-style-width="100%" data-theme="light">
  <a href="https://www.trustpilot.com/review/nsre.com" target="_blank" rel="noopener">Trustpilot</a>
</div>
<!-- End TrustBox widget -->

<!-- TrustBox widget - Grid -->
<div class="trustpilot-widget" data-locale="en-US" data-template-id="539adbd6dec7e10e686debee"
data-businessunit-id="58de7df20000ff00059f96e1" data-style-height="500px" data-style-width="100%" data-theme="light"
data-stars="1,2,3,4,5" data-review-languages="en">
  <a href="https://www.trustpilot.com/review/nsre.com" target="_blank" rel="noopener">Trustpilot</a>
</div>
<!-- End TrustBox widget -->

<!-- TrustBox widget - Micro TrustScore -->
<div class="trustpilot-widget" data-locale="en-US" data-template-id="5419b637fa0340045cd0c936"
data-businessunit-id="58de7df20000ff00059f96e1" data-style-height="20px" data-style-width="100%" data-theme="dark">
  <a href="https://www.trustpilot.com/review/nsre.com" target="_blank" rel="noopener">Trustpilot</a>
</div>
<!-- End TrustBox widget -->

<!-- TrustBox widget - Drop-Down -->
<div class="trustpilot-widget" data-locale="en-US" data-template-id="5418052cfbfb950d88702476"
data-businessunit-id="58de7df20000ff00059f96e1" data-style-height="30px" data-style-width="100%" data-theme="dark"
data-stars="1,2,3,4,5" data-review-languages="en">
  <a href="https://www.trustpilot.com/review/nsre.com" target="_blank" rel="noopener">Trustpilot</a>
</div>
<!-- End TrustBox widget -->

<!-- TrustBox widget - Carousel -->
<div class="trustpilot-widget" data-locale="en-US" data-template-id="53aa8912dec7e10d38f59f36"
data-businessunit-id="58de7df20000ff00059f96e1" data-style-height="140px" data-style-width="100%" data-theme="dark"
data-stars="1,2,3,4,5" data-review-languages="en">
  <a href="https://www.trustpilot.com/review/nsre.com" target="_blank" rel="noopener">Trustpilot</a>
</div>
<!-- End TrustBox widget -->

<!-- TrustBox widget - Slider -->
<div class="trustpilot-widget" data-locale="en-US" data-template-id="54ad5defc6454f065c28af8b"
data-businessunit-id="58de7df20000ff00059f96e1" data-style-height="240px" data-style-width="100%" data-theme="dark"
data-stars="1,2,3,4,5" data-review-languages="en">
  <a href="https://www.trustpilot.com/review/nsre.com" target="_blank" rel="noopener">Trustpilot</a>
</div>
<!-- End TrustBox widget -->

<!-- TrustBox widget - List -->
<div class="trustpilot-widget" data-locale="en-US" data-template-id="539ad60defb9600b94d7df2c"
data-businessunit-id="58de7df20000ff00059f96e1" data-style-height="500px" data-style-width="100%" data-theme="light"
data-stars="1,2,3,4,5" data-review-languages="en">
  <a href="https://www.trustpilot.com/review/nsre.com" target="_blank" rel="noopener">Trustpilot</a>
</div>
<!-- End TrustBox widget -->

 */

export default TrustBoxContainer;